// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8c92f9f9","88":"cd25a671","125":"ef999962","232":"77b509bf","310":"636941ca","942":"19908f0a"}[chunkId] + ".chunk.js";
};